/* istanbul ignore file */

import { IS_DEBUG } from '@utilities/browser';
import { Warn } from '@utilities/logging';

if (process.env.NODE_ENV === 'production' && IS_DEBUG) {
  Warn('SCRIPT cache check active');
  const regex = /\/\/# sourceMapping[U][R][L]=.*?_t=(.*)/;
  const observer = new PerformanceObserver((entries) => {
    entries.getEntriesByType('resource').forEach((res: PerformanceResourceTiming) => {
      const src = res.name;
      if (
        res.initiatorType !== 'script' ||
        !src.includes('CompiledAssets/UefaCom/js') ||
        !!document.querySelector(`script[src="${src}"]`)
      )
        return;

      fetch(src)
        .then((resp) => resp.text())
        .then((content) => {
          const match = regex.exec(content);
          if (match?.length && !src.includes(match[1])) {
            Warn('SCRIPT cache error, purge this script:', src);
          }
        });
    });
  });
  observer.observe({ entryTypes: ['resource'] });
}
